import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'recruitmentMailTemplates'

const getOne = (axios: IFactoryFunctionRequest) => ({ _id }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${_id}`,
  })
}

/**
 * officeId: 'none' for the templates for every office, an office id for the ones of that office.
 * usableInOfficeId: what a candidate of this office may receive (for everyone + of that office).
 */
const filter = (axios: IFactoryFunctionRequest) => ({ page = 0, search = '', limit = 10, moduleId = 4, searchFields = '', officeId = '', usableInOfficeId = '', countryId = '' }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: {
      page,
      search,
      limit,
      moduleId,
      ...(searchFields ? { searchFields } : {}),
      ...(officeId ? { officeId } : {}),
      ...(usableInOfficeId ? { usableInOfficeId } : {}),
      ...(countryId ? { countryId } : {}),
    },
  })
}

const create = (axios: IFactoryFunctionRequest) => (data) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest) => (id, { data }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
  })
}

const deleteOne = (axios: IFactoryFunctionRequest) => (id) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/delete/${id}`,
  })
}

const retreiveOneCreateMail = (axios: IFactoryFunctionRequest) => ({ _id }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/createMail/${_id}`,
  })
}

export default (axios: AxiosInstance) => ({
  getOne: getOne(useAxios(axios)),
  filter: filter(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  deleteOne: deleteOne(useAxios(axios)),
  retreiveOneCreateMail: retreiveOneCreateMail(useAxios(axios)),
})

